import { HomeSection, HomeSectionLoading } from '@/components/home';
import { ROUTES } from '@/config';
import { Stack } from '@/core/blocks';
import { Header } from '@/layout';
import { API } from '@/store/api';
import { useTranslation } from 'react-i18next';

const HomePage = () => {
  const { i18n } = useTranslation();

  const { error, isLoading, isFetching, data } = API.globalApi.useGetSettingsQuery(
    { locale: i18n.language },
    { skip: !i18n.language },
  );

  if (error) {
    return <p>Oh no, there was an error</p>;
  }

  return (
    <div className='flex flex-col h-screen bg-apple bg-cover bg-homepage relative'>
      <div className='w-full h-full'>
        <Header />
        <div className='flex justify-evenly items-center w-full h-full'>
          {isLoading || isFetching || !data ? (
            <>
              <HomeSectionLoading />
              <Stack upperClass='w-[3px] h-[680px]' lowerClass='w-[3px] h-[400px]' />
              <HomeSectionLoading />
            </>
          ) : (
            <>
              <HomeSection
                title={data.TITLE}
                subTitle={data.SUBTITLE}
                logo={data.LOGO}
                loaded={false}
                id={1}
                className='basis-1/2'
                route={ROUTES.CUPS.MAIN}
              />
              <Stack upperClass='w-[3px] h-[680px]' lowerClass='w-[3px] h-[400px]' />
              <HomeSection
                id={2}
                title={data.SECONDARY_TITLE}
                subTitle={data.SECONDARY_SUBTITLE}
                logo={data.SECONDARY_LOGO}
                loaded={false}
                className='basis-1/2'
                titleClass='max-w-[350px]'
                route={ROUTES.HISTORY}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
